import React from 'react';

const StepHeader = ({ stepTitle, stepDescription, area, className }) => {
  return (
    <>
    <div className="md:pr-10">
    {area !== 'Exclude' && (
      <p className="text-lg areaName"><strong>{area}</strong></p>
    )}
      {stepTitle && <h1 className={`text-left font-aileron font-bold text-3xl mb-5 min-[992px]:text-5xl min-[992px]:mb-10 ${className}`}>{stepTitle}</h1>}
      <div className="mb-10" dangerouslySetInnerHTML={{ __html: stepDescription }} />
      {area !== 'Masterclass' && area !== 'Exclude' && (
          <p className="mb-5"><strong>All Fields are required *</strong></p>
        )}
    </div>
    </>
  );
};

export default StepHeader;